import axios from '../axios';
import { getUserInfo } from '../auth';
import { getApiPath } from '../utils';
const baseUrl = getApiPath();
const userInfo = getUserInfo();
const elsAccount = userInfo.elsAccount || '307000';
const elsSubAccount = userInfo.elsSubAccount || '1001';

// POST /ElsAttachmentService/send
export const sendFiles = (params) => {
  return axios({
    url: `${baseUrl}/ElsAttachmentService/send`,
    method: 'post',
    data: params
  });
};

export const downloadServlet = (url) => {
  return axios({
    url: `${baseUrl}/servlet/downloadServlet?filePath=${url}`,
    method: 'get'
  });
};

export const uploadFile = (params) => {
  return axios({
    url: `${baseUrl}/FileService/uploadFile`,
    method: 'post',
    data: {
      elsAccount,
      elsSubAccount,
      ...params
    }
  });
};

export const download = (params) => {
  return axios({
    url: `${baseUrl}/FileService/downloadFile`,
    method: 'post',
    data: {
      elsAccount,
      elsSubAccount,
      ...params
    }
  });
};

export const attachmentServer = (action, params) => {
  if (action === 'update') {
    return axios({
      url: `${baseUrl}/ElsAttachmentService/${action}`,
      method: 'put',
      data: {
        ...params
      }
    });
  }
  return axios({
    url: `${baseUrl}/ElsAttachmentService/${action}`,
    method: 'post',
    data: {
      ...params
    }
  });
};

export const deleteAttachment = (uuid) => {
  return axios({
    url: `${baseUrl}/ElsAttachmentService/delete/${uuid}`,
    method: 'delete'
  });
};

export const getAttachmentServer = (uuid) => {
  return axios({
    url: `${baseUrl}/ElsAttachmentService/findDetail/${uuid}`,
    method: 'get'
  });
};
// 删除附件
export const deleteFile = (params) => {
  return axios({
    url: `${baseUrl}/ElsAttachmentService/delete/${params}`,
    method: 'delete',
    data: {}
  });
};

const uploadApi = {
  sendFiles,
  downloadServlet,
  uploadFile,
  attachmentServer,
  deleteAttachment,
  getAttachmentServer,
  download,
  deleteFile
};
export default uploadApi;
